import useMemo from "./useMemo";

export default function useRenderTime(){
	const memory = useMemo({time: 0});
	return ++memory.time;
}
